import dayjs from 'dayjs';
import duration, { Duration } from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

import { isString } from './type-functions';

dayjs.extend(duration);
dayjs.extend(relativeTime);
const timeParseRegEx = /(\d{0,2})([:|.|,|\b]?)(\d{0,2})\s?([P|A])?M?/i;
//const timeRegEx = /^(\d{1,})?((\D+)(\d{0,2}))?\D*$/;

/// <summary>
/// Needs to support:
/* 
  "1" as hours
  "56", "128" as minutes
  "12" as 12 am
  "12p" as 12 pm
  "1:56", "1,56", "1 56" as hours and minutes
  "1:56:12" as hours, minutes and seconds
  "1:56PM" as hours and minutes
  "1:56A" as hours and minutes
  "1:56P" as hours and minutes
  "1.2" as hours and fraction of an hour
  */
/// </summary>
const debug = false;
export class SDuration {
  static new(duration: unknown = undefined, time?: boolean): duration.Duration {
    time ??= false;
    if (debug) console.log('time conversion', time);
    if (duration === undefined || duration === null) {
      return dayjs.duration(0);
    }
    if (debug) console.log('Parsing Duration', duration);
    if (duration instanceof Date) {
      const lclDayJs = dayjs(duration);
      if (debug) console.log('Parsing DayJs of', lclDayJs);
      return dayjs.duration({ hours: lclDayJs.hour(), minutes: lclDayJs.minute() });
    }
    if (isString(duration) && duration.length > 0 && duration[0] !== 'P') {
      const match = timeParseRegEx.exec(duration);
      if (debug) console.log(`Parsing Duration ${duration}`, match);
      if (match && match.length > 1) {
        let hours = match[1].length > 0 ? parseInt(match[1]) : 0;
        let minutes = match[3] !== '' ? parseInt(match[3]) : 0;
        if (match[2] === '.') {
          if (debug) console.log(`Converting as decimal time of ${minutes} part of hour`, match[3].length);
          if (match[3].length == 1) minutes *= 10;
          minutes = (60 * minutes) / 100;
          if (debug) console.log(`Converting as decimal time of ${minutes} part of hour`);
        }

        if (time) {
          if (debug) console.log('Parsing as time', hours, minutes, match.length, match[4]);
          if (match.length > 4 && match[4]) {
            if (match[4].toLowerCase() == 'p') {
              if (hours < 12) {
                hours += 12; //don't combine up since the fallout is different
              }
            } else if (hours === 12) {
              hours = 0;
            }
          } else if (hours === 12) {
            hours = 0;
          }
        }
        if (debug) console.log(`Parsed Duration ${duration}`, hours, minutes);
        return dayjs.duration({ hours, minutes });
      }
      if (debug) console.log('Parsing Duration - No match', duration);
      return dayjs.duration(duration);
    }
    if (SDuration.isDuration(duration)) {
      if (debug) console.log('Parsing actual Duration', duration);
      return duration.clone();
    }
    if (debug) console.log('Parsing Duration: Unknown', duration);
    const response = dayjs.duration(duration);
    //console.log('Parsing Duration: Unknown into', response);
    return response;
  }

  static isDuration(duration: unknown): duration is Duration {
    return dayjs.isDuration(duration);
  }

  static ToAmPM(duration: duration.Duration): string {
    //console.log('ToAmPM', duration);
    const hours = duration.hours() ?? 0;
    const minutes = duration.minutes() ?? 0;
    //console.log('ToAmPM', hours, minutes);
    const amPm = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12;
    const hours12String = hours12 === 0 ? '12' : hours12.toString();
    const minutesString = minutes < 10 ? '0' + minutes.toString() : (minutes ?? 0).toString();
    const response = `${hours12String}:${minutesString} ${amPm}`;
    return response;
  }
}
